import { useEffect, useState } from "react";
import { Modal } from "../../../../theme/Component/Modal";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _PayrollEntityProperties } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicMultiSelectTable } from "../../../../theme/Component/BasicMultiSelecTable";
import { MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface Props {
    jsonTypePersons: string;
    jsonSelectedGrades?: string;
    label?: string;
    onChange: Function;
}


export const GradeExemptEditor = ({ jsonTypePersons, label, onChange, jsonSelectedGrades }: Props) => {
    const { instance, lista, setLista } = useDataBean(_PayrollEntityProperties);
    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [typePersons, setTypePersons] = useState<any[]>([]);
    const [selectedType, setSelectedType] = useState<string>("");

    const [selectedGrades, setSelectedGrades] = useState<any[]>([]);

    useEffect(() => {
        try {
            if (jsonTypePersons) {
                const parsed = JSON.parse(jsonTypePersons);
                if (Array.isArray(parsed)) {
                    setTypePersons(parsed);
                } else {
                    toast.error("jsonTypePersons no es un array válido.");
                }
            }
        } catch {
            toast.error("Error al parsear jsonTypePersons.");
        }
    }, [jsonTypePersons]);

    useEffect(() => {
        try {
            if (jsonSelectedGrades) {
                const parsed = JSON.parse(jsonSelectedGrades);
                if (Array.isArray(parsed)) {
                    const enriched = parsed.map(item => ({
                        DataBeanProperties: {
                            IDCreditProperties: item.IDCreditProperties,
                            Description: item.Description
                        }
                    }));
                    setSelectedGrades(enriched);
                } else {
                    toast.error("jsonSelectedGrades no es un array válido.");
                }
            }
        } catch {
            toast.error("Error al parsear jsonSelectedGrades.");
        }
    }, [jsonSelectedGrades]);


    const handleSearch = () => {
        if (!selectedType) {
            toast.warn("Seleccione un Tipo de Persona.");
            return;
        }
        const selected = typePersons.find(p => p.IDCreditProperties == parseInt(selectedType));
        if (selected?.CodigoGrado) {
            instance.getCreditPropertyDefinition(null, null, selected.CodigoGrado).then(resp => {
                setLista(resp.List);
            }).catch(err => toast.error("Error en la consulta de grados."));
        } else {
            toast.error("No se encontró la definición del grupo.");
        }
    };

    const head = [
        { title: 'ID', property: 'IDCreditProperties', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Description', visible: true },
    ];

    const returnData = () => {
        const normalized = selectedGrades.map(item => ({
            IDCreditProperties: item.DataBeanProperties.IDCreditProperties,
            Description: item.DataBeanProperties.Description
        }));
        onChange(JSON.stringify(normalized));
        setModal({ ...modal, view: false });
    };


    useEffect(() => {
        if (selectedType) {
            handleSearch();
        } else {
            setLista([])
        }
    }, [selectedType])

    return (
        <>
            <label>{label || 'Grados Exentos'}</label>
            <div
                className="form-control d-flex flex-wrap align-items-center p-2"
                style={{ minHeight: '100px', cursor: 'pointer' }}
                onClick={() => setModal({ ...modal, view: true, name: "Selección de Grados" })}
            >
                {selectedGrades.length === 0 && (
                    <span className="text-muted">Seleccione grados exentos...</span>
                )}
                {selectedGrades.map((item) => (
                    <span
                        key={item.DataBeanProperties.IDCreditProperties}
                        className="badge bg-primary text-light m-1 d-flex align-items-center"
                        style={{ fontSize: '0.9rem' }}
                    >
                        {item.DataBeanProperties.Description}
                        <button
                            type="button"
                            className="btn-close btn-close-white ms-2"
                            style={{ fontSize: '0.7rem' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                const updatedGrades = selectedGrades.filter(
                                    grade => grade.DataBeanProperties.IDCreditProperties !== item.DataBeanProperties.IDCreditProperties
                                );
                                const normalized = updatedGrades.map(item => ({
                                    IDCreditProperties: item.DataBeanProperties.IDCreditProperties,
                                    Description: item.DataBeanProperties.Description
                                }));
                                setSelectedGrades(updatedGrades);
                                onChange(JSON.stringify(normalized));
                            }}
                        />
                    </span>
                ))}
            </div>



            <Modal modal={modal} updateModal={setModal} eventModal={returnData} >
                <div className="row">
                    <div className="col-md-12">
                        <label >Tipo de Persona</label>
                        <select
                            className="form-select"
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            <option value="">Seleccione Tipo de Persona</option>
                            {typePersons.map((item) => (
                                <option key={item.IDCreditProperties} value={item.IDCreditProperties}>
                                    {item.Description}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-12 mt-2">
                        <BasicMultiSelectTable
                            clearnotListBody
                            head={head}
                            body={lista}
                            bodyResult={selectedGrades}
                            keyId="IDCreditProperties"
                            updateValues={({ bodyResult }) => setSelectedGrades(bodyResult)}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};
